import React from 'react';
import {Link} from 'gatsby';

const Menu = () => {
  return (
    <div className="menu">
      <div className="menu__content">
        <ul className="menu__list">
          <li className="menu__list-item">ʕ•́ᴥ•̀ʔ</li>
          <li className="menu__list-item">
            <Link to="/">Bài viết</Link>
          </li>
          <li className="menu__list-item">
            <Link to="/about">About me</Link>
          </li>
          <li className="menu__list-item">
            <a href="/Quyen_Luu_resume.pdf" target="_blank">Resume</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Menu;
